(function () {

  function initStickyCart(sticky) {

    if (sticky.dataset.initialized === "true") return;

    const sectionId = sticky.dataset.section;

    /*
     * Find product section BEFORE moving sticky bar
     */
    const productSection =
      document.querySelector(`#MainProduct-${sectionId}`) ||
      sticky.closest(".shopify-section") ||
      document;

    const originalButton =
      productSection.querySelector(".product-form__submit");

    const stickyButton =
      sticky.querySelector("[data-sticky-cart-button]");

    const stickyPrice =
      sticky.querySelector(".aircrafttag-sticky-cart__price");

    if (!originalButton || !stickyButton) return;


    /* ==========================================
       IMPORTANT:
       Move sticky bar directly into BODY
       so position: fixed is relative to viewport
       ========================================== */

    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }


    /* ==========================================
       Sync button
       ========================================== */

    function syncButton() {

      stickyButton.disabled = originalButton.disabled;

      const originalText =
        originalButton.querySelector("span")?.textContent.trim() ||
        originalButton.textContent.trim();

      if (originalText) {
        stickyButton.textContent = originalText;
      }

    }


    /* ==========================================
       Sticky button clicks original Shopify button
       ========================================== */

    stickyButton.addEventListener("click", function () {

      if (!originalButton.disabled) {
        originalButton.click();
      }

    });


    /* ==========================================
       Show only when original button is gone
       ========================================== */

    const observer = new IntersectionObserver(
      function (entries) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {
            sticky.classList.remove("is-visible");
          } else {
            sticky.classList.add("is-visible");
          }

        });

      },
      {
        threshold: 0
      }
    );

    observer.observe(originalButton);


    /* ==========================================
       Watch sold-out / variant changes
       ========================================== */

    const buttonObserver =
      new MutationObserver(syncButton);

    buttonObserver.observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });


    /* ==========================================
       Sync price
       ========================================== */

    function syncPrice() {

      const priceElement =
        productSection.querySelector(
          `[id^="price-${sectionId}"] .price-item--sale`
        ) ||
        productSection.querySelector(
          `[id^="price-${sectionId}"] .price-item--regular`
        ) ||
        productSection.querySelector(
          `[id^="price-${sectionId}"] .price-item`
        ) ||
        productSection.querySelector(".price .price-item--sale") ||
        productSection.querySelector(".price .price-item--regular") ||
        productSection.querySelector(".price .price-item");

      if (priceElement && stickyPrice) {
        stickyPrice.textContent =
          priceElement.textContent.trim();
      }

    }


    const priceContainer =
      productSection.querySelector(
        `[id^="price-${sectionId}"]`
      ) ||
      productSection.querySelector(".price");

    if (priceContainer) {

      const priceObserver =
        new MutationObserver(syncPrice);

      priceObserver.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });

    }


    syncButton();
    syncPrice();

    sticky.dataset.initialized = "true";
  }


  function initAllStickyCarts() {

    document
      .querySelectorAll("[data-sticky-cart]")
      .forEach(initStickyCart);

  }


  document.addEventListener(
    "DOMContentLoaded",
    initAllStickyCarts
  );


  document.addEventListener(
    "shopify:section:load",
    initAllStickyCarts
  );

})();